import { render, staticRenderFns } from "./ValuesTable.vue?vue&type=template&id=694b1e60&"
import script from "./ValuesTable.vue?vue&type=script&lang=js&"
export * from "./ValuesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports